import { createStyles } from 'antd-style';
export var useStyles = createStyles(function () {
  return {
    container: {
      '& .ant-form-item-label label': {
        width: 'unset !important'
      },
      '& .ant-form-item-label label::after': {
        display: 'unset !important'
      }
    }
  };
});